<template>
  <router-view />
</template>
<style>
@import "./styles/main.scss";
</style>
